function c(o, t) {
  var n;
  (n = o.scrollIntoView) == null || n.call(o, t);
}
export {
  c as scrollIntoView
};
